import { ReactNode } from 'react';
import { Paper } from '@mui/material';

import { CircularProgress } from '@occc-app/design-system';

import { RetailerNetworkErrorMessage } from './retailer-network-error-message.component';
import { RetailerNetworkNoData } from './retailer-network-no-data.component';

type RetailerNetworkDataLoadingProps = {
  isLoading: boolean;
  hasData: boolean;
  hasError?: boolean;
  children?: ReactNode;
};

const CenteredPaper = ({ children }: { children: ReactNode }) => (
  <Paper
    elevation={2}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 1,
      p: 6,
    }}
  >
    {children}
  </Paper>
);

export const RetailerNetworkDataLoading = ({
  isLoading,
  hasError,
  hasData,
  children,
}: RetailerNetworkDataLoadingProps) => {
  if (isLoading) {
    return (
      <CenteredPaper>
        <CircularProgress />
      </CenteredPaper>
    );
  }

  if (hasError) {
    return (
      <CenteredPaper>
        <RetailerNetworkErrorMessage />
      </CenteredPaper>
    );
  }

  if (!hasData) {
    return (
      <CenteredPaper>
        <RetailerNetworkNoData />
      </CenteredPaper>
    );
  }

  return children;
};
